import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9788ab0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-page-header" }
const _hoisted_2 = { class: "select-date-wrap xag-flex lr y-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-date-text" }, "选择日期", -1))
const _hoisted_4 = { class: "index-select-date" }
const _hoisted_5 = {
  key: 0,
  class: "flight-list"
}
const _hoisted_6 = { class: "flight-other-msg" }
const _hoisted_7 = { class: "flight-start-end" }
const _hoisted_8 = { class: "flight-timelong" }
const _hoisted_9 = {
  key: 1,
  class: "flight-nodata"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/images/nodata.png" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flight-nodata-text" }, "所选日期无作业日志", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "confirm-text" }, "确定", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cancel-text" }, "取消", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "popup-title" }, "故障发生时间"),
  /*#__PURE__*/_createElementVNode("div", { class: "popup-sectitle" }, "请选择准确的故障发生时间")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", {
    class: "appeal-page",
    style: _normalizeStyle({ 'padding-top': `${Number(_ctx.pagePaddingTop)}px` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_app_header, {
        title: "选择日志",
        isReturnLeftEvent: true,
        onLeftClick: _ctx.handleBackPage,
        rightTxt: "确定",
        rightCanClick: true,
        onRightClick: _ctx.handlerightConfirm
      }, null, 8, ["onLeftClick", "onRightClick"])
    ]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.refreshLoading,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.refreshLoading) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "select-date-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleOpenPopop && _ctx.handleOpenPopop(...args)))
          }, [
            _hoisted_3,
            _createVNode(_component_van_icon, {
              class: "select-date-icon",
              name: _ctx.showPopop ? 'arrow-down' : 'arrow',
              size: "16"
            }, null, 8, ["name"])
          ]),
          (_ctx.isMiniProgram)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlerightConfirm && _ctx.handlerightConfirm(...args))),
                class: _normalizeClass(_ctx.flightChecked.length > 0 ? 'xag-effect' : 'xag-disabled')
              }, "确定", 2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.handleDateFormatter(new Date(_ctx.indexSelectDate))), 1),
        (_ctx.flightList && _ctx.flightList.length >= 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_van_list, {
                loading: _ctx.listOnloading,
                "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listOnloading) = $event)),
                finished: _ctx.listOnFinished,
                "finished-text": "没有更多了",
                onLoad: _ctx.listOnLoadData,
                offset: "100",
                direction: "down"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_checkbox_group, {
                    modelValue: _ctx.flightChecked,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.flightChecked) = $event)),
                    "checked-color": "#00C378"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flightList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass({ 'flight-item': true, 'first-item': index == 0 ? true : false }),
                          key: index
                        }, [
                          _createVNode(_component_van_checkbox, {
                            name: item,
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, _toDisplayString(item.workTime), 1),
                                _createElementVNode("div", _hoisted_8, "时长" + _toDisplayString(item.longStr), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["name"])
                        ], 2))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["loading", "finished", "onLoad"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12)),
        _createVNode(_component_van_popup, {
          position: "bottom",
          round: "",
          show: _ctx.showPopop,
          "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showPopop) = $event)),
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_datetime_picker, {
              modelValue: _ctx.currentDate,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentDate) = $event)),
              type: "date",
              onCancel: _ctx.handleCancel,
              onConfirm: _ctx.handleConfirm,
              "min-date": _ctx.minDate
            }, {
              confirm: _withCtx(() => [
                _hoisted_13
              ]),
              cancel: _withCtx(() => [
                _hoisted_14
              ]),
              title: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["modelValue", "onCancel", "onConfirm", "min-date"])
          ]),
          _: 1
        }, 8, ["show"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ], 4))
}